/* THE DENIM PARLOR — BLUE ROOM
 * Two jobs:
 *   1. Add to cart over AJAX instead of a raw form POST. The raw POST left
 *      the page, which dropped the ?preview_theme_id session and handed the
 *      customer to whichever cart the live theme renders — the reason items
 *      looked like they vanished.
 *   2. Render our own tray of what is in the cart, with a REMOVE on every
 *      line, so seeing and clearing an order never depends on the theme's
 *      drawer working.
 * Zero backslash literals — the MCP theme-file transport corrupts them.
 */
(function () {
  'use strict';

  function money(cents, format) {
    var n = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format
        .replace(/[{][{][ ]*amount[ ]*[}][}]/, Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 }))
        .replace(/[{][{][ ]*amount_no_decimals[ ]*[}][}]/, Math.round(cents / 100).toLocaleString('en-US'));
    }
    return '$' + n;
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function initTray(tray) {
    var fmt = tray.getAttribute('data-money-format') || '';

    function render(cart) {
      if (!cart || !cart.items || !cart.items.length) {
        tray.innerHTML = '<div class="hsdb-card"><div class="cap"><b>ご注文内容</b><small>YOUR TRAY</small></div>'
          + '<div class="inner"><p class="hsdb-hint">まだ空です · Nothing on the counter yet.</p></div></div>';
        return;
      }
      var rows = cart.items.map(function (it) {
        // Properties starting with _ are machine-readable; keep them out of
        // the customer's face but keep everything else visible.
        var props = Object.keys(it.properties || {})
          .filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; })
          .map(function (k) {
            return '<li><b>' + esc(k) + ':</b> ' + esc(it.properties[k]) + '</li>';
          }).join('');
        return '<li class="hsdb-tray-row">'
          + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '<span class="hsdb-tray-noimg">🧵</span>')
          + '<div class="hsdb-tray-body">'
          + '<p class="hsdb-tray-title">' + esc(it.product_title) + '</p>'
          + (it.variant_title && it.variant_title !== 'Default Title'
              ? '<p class="hsdb-tray-variant">' + esc(it.variant_title) + '</p>' : '')
          + (props ? '<ul class="hsdb-tray-props">' + props + '</ul>' : '')
          + '</div>'
          + '<div class="hsdb-tray-right">'
          + '<span class="hsdb-tray-price">' + money(it.line_price, fmt) + '</span>'
          + '<button type="button" class="hsdb-tray-remove" data-hsdb-remove="' + esc(it.key) + '">REMOVE ×</button>'
          + '</div></li>';
      }).join('');

      tray.innerHTML = '<div class="hsdb-card"><div class="cap"><b>ご注文内容</b><small>YOUR TRAY — ' + cart.item_count + ' ITEM(S)</small></div>'
        + '<div class="inner">'
        + '<ul class="hsdb-tray-list">' + rows + '</ul>'
        + '<p class="hsdb-tray-total"><span>合計 · TOTAL</span><span>' + money(cart.total_price, fmt) + '</span></p>'
        + '<a class="hsdb-btn go big" href="/checkout">お会計へ · CHECKOUT →</a>'
        + '<a class="hsdb-btn ghost" href="/cart" style="width:100%; margin-top:8px;">VIEW FULL CART</a>'
        + '</div></div>';
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { /* leave whatever is on screen */ });
    }

    tray.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-hsdb-remove]') : null;
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      btn.textContent = 'REMOVING…';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: btn.getAttribute('data-hsdb-remove'), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(function () { refresh(); });
    });

    document.addEventListener('hsdb:cart-changed', refresh);
    refresh();
  }

  function initForm(form) {
    var errEl = form.querySelector('[data-hsdb-error]');
    function fail(msg) {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      else window.alert(msg);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'カートへ… · ADDING…'; }
      if (errEl) errEl.hidden = true;

      // FormData honours disabled inputs correctly (the SIZE / SIZE RUN
      // toggle relies on that), so post exactly what the form holds.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'CART ERROR'); });
          return r.json();
        })
        .then(function () {
          var entity = form.getAttribute('data-entity');
          if (!entity) return null;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ attributes: { entity: entity } })
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('hsdb:cart-changed', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var tray = document.querySelector('[data-hsdb-tray]');
          if (tray) tray.scrollIntoView({ behavior: 'smooth', block: 'center' });
        })
        .catch(function (err) {
          fail((err.message || 'SOMETHING BROKE. TRY AGAIN.').toUpperCase());
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hsdb-form]'), initForm);
    Array.prototype.forEach.call(document.querySelectorAll('[data-hsdb-tray]'), initTray);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
